import { useState } from "react";
import { injectIntl } from "react-intl";
import TypeaheadBox from "../Form/TypeaheadBox";
import intlShape from "../../shapes/intlShape";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";

type Props = {
  api: apiShape;
  intl: intlShape;
  name: string;
  notifier: notifierShape;
  assetId?: number;
  values: {
    product?: $TSFixMe;
  };
};

export function CompanyTypeahead(props: Props) {
  const [companies, setCompanies] = useState();
  const [fetching, setFetching] = useState();
  const { api, notifier, intl, values, name, assetId } = props;

  const loadCompanies = async (searchText = "") => {
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
      setFetching(true);

      const endpoint = assetId
        ? `/assets/${assetId}/company-options`
        : "/companies";

      const response = await api.getAll(endpoint, {
        include: "tenant",
        name: `${searchText}*`,
      });

      setCompanies(
        response.companies.map((company: $TSFixMe) => ({
          id: company.id,
          name: company.name,
          tenantId: company?.tenant?.id,
          tenantPublic: company?.tenant?.public,
          tenantName: company?.tenant?.name,
        })),
      );
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const selectedCompany = values[name];

  return (
    <TypeaheadBox
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ info: string | null; options: undefined; f... Remove this comment to see the full error message
      info={
        selectedCompany?.new
          ? intl.formatMessage({ id: "company_typeahead.new_info" })
          : null
      }
      options={companies}
      fetching={fetching}
      loadOptions={loadCompanies}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      loadOptionsOnMount={!values[name]}
    />
  );
}

export default injectIntl(withNotifier(withApi(CompanyTypeahead)));
